import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { registerEnum } from '@adornis/baseql/metadata/register.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { SLAType } from './SLAType.js';

export enum WorkflowType {
  PARKLAND = 'PARKLAND',
  'DELLFRANCE' = 'DELLFRANCE',
  'OSS' = 'OSS',
  'VERIZON' = 'VERIZON',
  UNKNOWN = 'UNKNOWN',
}

registerEnum({ enum: WorkflowType, name: 'WorkflowType' });

@Entity()
export class Client extends MongoEntity {
  static override _class = 'Client';
  static override _collectionName = 'clients';

  @validate(nonOptional())
  @Field(() => String)
  name: Maybe<string>;

  @validate(nonOptional())
  @Field(() => String)
  managerPhoneNumber: Maybe<string>;

  @Field(() => [SLAType])
  slaTypes: Maybe<SLAType[]>;

  @Field(() => Boolean)
  enabled: Maybe<boolean>;

  @Field(() => WorkflowType)
  workflowType: Maybe<WorkflowType>;

  /**
   * Per-client feature opt-in list. A feature is OFF unless its key is present here, so an
   * empty/absent list means no autonomous workflow features run for the client. Stored as raw
   * strings; see `ClientFeatureKey` / `WORKFLOW_FEATURES` in ./client-features.js for the valid
   * keys and which apply to each workflow type. Evaluate with `isClientFeatureEnabled`
   * (../client-feature-flags.js) rather than reading directly.
   */
  @Field(() => [String])
  enabledFeatures: Maybe<string[]>;
}
